import store from '../store/Store';
import actionTypes from '../actionTypes/actionTypes';

async function changeRoute(data) {
	const route = data.route ? data.route : {};

	const action = {
		type: actionTypes.CHANGE_ROUTE,
		data
	};

	store.dispatch(action);
}

const routeActions = {
	changeRoute
}

export default routeActions;